import * as d3 from "d3";

type changePlotOrder = (
  plotClassName: string,
  isBoxplotInFront: boolean,
) => void;

export const changeSwarmBoxPlotOrder: changePlotOrder = (
  plotClassName,
  isBoxplotInFront,
) => {
  const svg = d3.select(`svg.${plotClassName}`);
  const betweenPlotPanel = svg.select("g.between-plot-panel");
  const bgRect = svg.select("rect.bg-rect");
  const boxplot = svg.selectAll("g.box");
  const swarm = svg.selectAll(".swarm");

  const xAxis = svg.selectAll(".x-axis");
  const yAxis = svg.selectAll(".y-axis");
  const texts = svg.selectAll("text");

  if (isBoxplotInFront) {
    betweenPlotPanel.raise();
    boxplot.style("opacity", 0.9).raise();
    swarm.style("opacity", 0.2).lower();
    bgRect.lower();
  } else {
    betweenPlotPanel.raise();

    swarm.style("opacity", 0.8).raise();
    boxplot.style("opacity", 0.3).lower();
    bgRect.lower();
  }
  svg.selectAll(".clicked").style("opacity", 1).raise();
  svg.selectAll(".muted").style("opacity", 0.2).lower();
  svg.selectAll(".focal").style("opacity", 1).raise();
  xAxis.raise();
  yAxis.raise();
  texts.raise();
};
